import {
  USER_GET_PERMISSIONS,
  USER_INIT,
  USER_SET_IS_LOGIN,
  USER_SET_PERMISSIONS,
  USER_TOKEN_REFRESH,
  USER_SET_PROFILE,
  USER_GET_PROFILE,
  USER_PATCH_PROFILE,
  USER_PROFILE_SET_ERROR,
  SET_USER_SETTINGS,
  GET_USER_SETTINGS,
  SHOW_USER_SETTINGS_LOADER,
  HIDE_USER_SETTINGS_LOADER,
  PATCH_USER_SETTINGS
} from "./actionTypes"

export const userTokenRefresh = history => ({
  type: USER_TOKEN_REFRESH,
  payload: history,
});

export const userSetIsLogin = isLogin => ({
  type: USER_SET_IS_LOGIN,
  payload: isLogin,
});

export const userInit = history => ({
  type: USER_INIT,
  payload: history,
});

export const userGetPermissions = () => ({
  type: USER_GET_PERMISSIONS,
});

export const userSetPermissions = permissions => ({
  type: USER_SET_PERMISSIONS,
  payload: permissions,
});

export const userGetProfile = id => ({
  type: USER_GET_PROFILE,
  payload: id,
});

export const userSetProfile = data => ({
  type: USER_SET_PROFILE,
  payload: data,
});

export const userPatchProfile = (id, data = {}, type = '') => ({
  type: USER_PATCH_PROFILE,
  payload: { id, data, type },
});

export const setErrorUserProfile = status => ({
  type: USER_PROFILE_SET_ERROR,
});

export const setUserSettings = payload => ({
  type: SET_USER_SETTINGS,
  payload
});

export const getUserSettings = payload => ({
  type: GET_USER_SETTINGS,
  payload
});

export const patchUserSettings = payload => ({
  type: PATCH_USER_SETTINGS,
  payload
});

export const showUserSettingsLoader = () => ({
  type: SHOW_USER_SETTINGS_LOADER,
});

export const hideUserSettingsLoader = () => ({
  type: HIDE_USER_SETTINGS_LOADER,
});
